import { render, staticRenderFns } from "./viewRenewInsurance.vue?vue&type=template&id=115603c9&scoped=true&"
import script from "./viewRenewInsurance.vue?vue&type=script&lang=ts&"
export * from "./viewRenewInsurance.vue?vue&type=script&lang=ts&"
import style0 from "./viewRenewInsurance.vue?vue&type=style&index=0&id=115603c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115603c9",
  null
  
)

export default component.exports